import React, { Suspense, useMemo } from "react";
import type { FileConfig, FilePlayerProps } from "react-player/file";
const ReactPlayer = React.lazy(() => import("react-player/file"));

type Props = Omit<FilePlayerProps, "url"> & {
  videoId: string | undefined;
  trackingTitle: string | undefined;
};

const WidenBaseVideoPlayer: React.FC<Props> = ({
  videoId,
  trackingTitle,
  config,
  ...props
}) => {
  const updatedConfig: FileConfig = useMemo(() => {
    return {
      ...config,
      hlsOptions: {
        autoStartLoad: true
      },
      attributes: {
        "data-matomo-title": trackingTitle
      }
    } satisfies FileConfig;
  }, [config, trackingTitle]);

  return (
    <Suspense>
      <ReactPlayer
        {...props}
        data-matomo-title={trackingTitle}
        url={`${process.env.GATSBY_WIDEN_VIDEO_PROXU_URL}/${videoId}.m3u8`}
        config={updatedConfig}
      />
    </Suspense>
  );
};

export default WidenBaseVideoPlayer;
